module.exports = __webpack_public_path__ + "img/ff1-min.jpg";